import './App.css';
import Navbar from "./components/Navbar/Navbar"; 
import {NotificationProvider} from './components/ui/notification';
import React, { useState, useEffect, Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Form
} from "react-router-dom";

const Home = lazy(() => import('./components/Mainpage/mainpage'));
const RegisterCompany = lazy(() => import('./components/Login/Register/RegisterCompany'));
const RegisterStudent = lazy(() => import('./components/Login/Register/RegisterStudent'));
const RegisterSchool = lazy(() => import('./components/Login/Register/RegisterSchool'));
const LoginPage = lazy(() => import('./components/Login/Login/Login'));
const Footer = lazy(() => import('./components/Footer/Footer'));
const OgrenciGenel = lazy(() => import('./components/Student/OgrenciGenel'));
const Myardyonetim = lazy(() => import('./components/School/KordinatorMy/Myardyonetim'));
const Company = lazy(() => import('./components/Company/Company'));
const Ogretmen = lazy(() => import('./components/School/KordinatorOgretmen/KordinatorOgretmen'));
const Interview = lazy(() => import('./components/adversite/Interview'));
const JobListings = lazy(() => import('./components/adversite/JobListings'));


function App() {
  return (
      <NotificationProvider>
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/OgrenciKayit" element={<RegisterStudent />} />
        <Route path="/OkulKayitOgretmen" element={<RegisterSchool />} />
        <Route path="/hakkimizda" element={<Home />} />
        <Route path="/iletisim" element={<Home />} />
        <Route path="/Giris" element={<LoginPage />} />
        <Route path="/IsletmeKayit" element={<RegisterCompany />} />
        <Route path="/Myardyonetim" element={<Myardyonetim />} />
        <Route path="/OgrenciGenel" element={<OgrenciGenel />} />
        <Route path="/Isletme" element={<Company />} />
        <Route path="/Ogretmen" element={<Ogretmen />} />
        <Route path="/is-ilanlari" element={<JobListings />} />
        <Route path="/mulakat/:id" element={<Interview />} />


        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </div>
      </NotificationProvider>
  );
}

export default App;
